import { Component, Optional, ViewEncapsulation } from '@angular/core';
import { MmDialogRefService } from '@metromarkets/components';

import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { EmployeeService } from '~app/modules/authorization/services/employee.service';
import {
  SESSION_STORAGE_CUSTOMER_BUSINESS_CDM_ID_KEY,
  SESSION_STORAGE_CUSTOMER_CDM_ID_KEY,
} from '~app/core/modules/identity/constants/identity.constant';
import { ExtendImpersonationTokenInterceptor } from '~app/core/modules/identity/interceptors/extend-impersonation-token.interceptor';

@Component({
  selector: 'app-extend-impersonation-session-dialog',
  templateUrl: './extend-impersonation-session-dialog.component.html',
  styleUrls: ['./extend-impersonation-session-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExtendImpersonationSessionDialogComponent {
  accountType$ = this.accountInfoService.accountType$;

  constructor(
    @Optional() public dialogRef: MmDialogRefService<any>,
    private accountInfoService: AccountInfoService,
    private employeeService: EmployeeService
  ) {}

  public handleStartWithNewCustomer = (e) => {
    e?.preventDefault();
    this.employeeService.stopImpersonatingCustomer();
    this.dialogRef.close();
  };

  public onExtendImpersonationSession() {
    const customerCdmId = sessionStorage.getItem(SESSION_STORAGE_CUSTOMER_CDM_ID_KEY);
    const businessCdmId = sessionStorage.getItem(SESSION_STORAGE_CUSTOMER_BUSINESS_CDM_ID_KEY);
    const hasDigitalIdentity = true; //we are extending the impersonation session,
    this.employeeService
      .impersonateCustomer(customerCdmId, businessCdmId, null, hasDigitalIdentity, { redirectToCatalog: false })
      .subscribe(() => {
        ExtendImpersonationTokenInterceptor.resetImpersonatedAuthFailed();
        if(!!this.dialogRef.containerInstance.config.data?.reloadPostRefresh){
          window.location.reload();
        }
      });
    this.dialogRef.close();
  }
}
